var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-chart-container",class:{ 'mobile': _vm.isMobile, 'desktop': !_vm.isMobile }},[_c('line-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }